module.exports = __webpack_public_path__ + "img/13.efce1bef.png";